<template>
  <div id="root">
    <div :class="cssClasses">
      <router-view
        name="content"
        :title="title.toUpperCase()"
        :is-x-small="screen.isXSmall"
        :is-large="screen.isLarge"
      ></router-view>
      <GcHotKey />
    </div>
  </div>
</template>

<script>
import { sizes, subscribe, unsubscribe } from "./_helpers/browser/media-query";
import { authComputed } from "./_store/helpers";
// import cachingHub from "./_helpers/hubs/cachingHub";

function getScreenSizeInfo() {
  const screenSizes = sizes();

  return {
    isXSmall: screenSizes["screen-x-small"],
    isLarge: screenSizes["screen-large"],
    cssClasses: Object.keys(screenSizes).filter((cl) => screenSizes[cl]),
  };
}

export default {
  name: "app",
  data() {
    return {
      title: this.$appInfo.title,
      screen: getScreenSizeInfo(),
    };
  },
  computed: {
    ...authComputed,
    cssClasses() {
      return ["app"].concat(this.screen.cssClasses);
    },
  },
  methods: {
    screenSizeChanged() {
      this.screen = getScreenSizeInfo();
    },
  },

  mounted() {
    subscribe(this.screenSizeChanged);
    this.$store.dispatch("profile/setInitialApplicationMode");
    // TODO: enable realtime communication if required, for cache invalidation and any socket communication related functionality
    // cachingHub.client.on("SendMessage", (message) => {
    //   // eslint-disable-next-line no-console
    //   console.log("SignalR message", message);
    // });

    // try {
    //   cachingHub.client.start().then(() => {
    //     cachingHub.client.invoke("JoinCachingGroup");
    //   });
    // } catch (err) {
    //   // eslint-disable-next-line no-console
    //   console.log("Error connecting to SignalR Hub!", err);
    // }
  },
  async beforeMount() {
    if (this.currentUser) {
      await this.$store.dispatch("globalFields/setInitialGlobalFields");
      await this.$store.dispatch("defaultDateSettings/setCurrentFiscalData");
    }
  },

  beforeDestroy() {
    unsubscribe(this.screenSizeChanged);
  },

  components: {},
};
</script>

<style lang="scss">
html,
body {
  margin: 0px;
  min-height: 100%;
  height: 100%;
}

#root {
  height: 100%;
}

* {
  box-sizing: border-box;
}

.app {
  @import "./assets/styles/variables.base.scss";
  background-color: darken($base-bg, 5);
  display: flex;
  height: 100%;
  width: 100%;
}
</style>
